import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";

export default function* watcherDeleteOrderSaga() {
  yield takeEvery("DELETE_ORDERS", workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: "DISPLAY_LOADER", payload: payload });
    var payload = {};

    formatUrl = `api/SalesTransactionV2/delete-orders?orderId=${action.payload}`;
    yield request("post", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    var formatUrl = `api/SalesTransactionV2/unpaid`;
    yield request("get", payload, formatUrl).then((response) => {
      payload = response;
    });

    yield put({ type: "ORDERS_LIST", payload: payload });
    yield put({ type: "DISPLAY_LOADER", payload: payload });
  } catch (e) {
    console.log(e);
    console.log("product-saga", e);
    console.log("product-saga", e.response);
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
    yield put({ type: "DISPLAY_LOADER", payload: payload });
  }
}
